import { useWindowDimensions } from "react-native";

/**
 * Breakpoints that mirror the Tailwind `screens` config in tailwind.config.js.
 * Keep these in sync if the config changes.
 */
export const BREAKPOINTS = {
  sm: 375, // iPhone SE
  md: 393, // iPhone 15 Pro
  tablet: 768, // iPad — wide-screen web layouts kick in here
  lg: 1280, // Desktop web
} as const;

/**
 * Returns `true` when the viewport/window width is at least 768 px
 * (the `tablet` breakpoint), regardless of platform.
 *
 * This means wide layouts are activated on iPad, Android tablets, and
 * wide browser windows alike. If you need to restrict wide layouts to
 * web only, combine this hook with a `Platform.OS === "web"` guard at
 * the call site.
 */
export function useIsWideScreen(): boolean {
  const { width } = useWindowDimensions();
  return width >= BREAKPOINTS.tablet;
}
